/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
 /* tslint:disable */

import * as import0 from '@angular/core/src/render/api';
import * as import1 from '@angular/core/src/linker/view';
import * as import2 from '@angular/core/src/linker/element';
import * as import3 from './bing-map-info-window';
import * as import4 from '@angular/core/src/linker/query_list';
import * as import5 from '@angular/core/src/linker/view_utils';
import * as import6 from '@angular/core/src/di/injector';
import * as import7 from '@angular/core/src/linker/view_type';
import * as import8 from '@angular/core/src/change_detection/change_detection';
import * as import9 from '../services/info-window-manager';
import * as import10 from '@angular/core/src/metadata/view';
import * as import11 from '@angular/core/src/linker/component_factory';
var renderType_BingMapInfoWindow_Host:import0.RenderComponentType = (null as any);
class _View_BingMapInfoWindow_Host0 extends import1.AppView<any> {
  _el_0:any;
  /*private*/ _appEl_0:import2.AppElement;
  _BingMapInfoWindow_0_4:import3.BingMapInfoWindow;
  _query_BingMapInfoWindowAction_0_0:import4.QueryList<any>;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import2.AppElement) {
    super(_View_BingMapInfoWindow_Host0,renderType_BingMapInfoWindow_Host,import7.ViewType.HOST,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import2.AppElement {
    this._el_0 = this.selectOrCreateHostElement('bing-map-info-window',rootSelector,(null as any));
    this._appEl_0 = new import2.AppElement(0,(null as any),this,this._el_0);
    var compView_0:any = viewFactory_BingMapInfoWindow0(this.viewUtils,this.injector(0),this._appEl_0);
    this._BingMapInfoWindow_0_4 = new import3.BingMapInfoWindow(this.parentInjector.get(import9.InfoWindowManager));
    this._query_BingMapInfoWindowAction_0_0 = new import4.QueryList<any>();
    this._appEl_0.initComponent(this._BingMapInfoWindow_0_4,[],compView_0);
    compView_0.create(this._BingMapInfoWindow_0_4,this.projectableNodes,(null as any));
    this.init([].concat([this._el_0]),[this._el_0],[],[]);
    return this._appEl_0;
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import3.BingMapInfoWindow) && (0 === requestNodeIndex))) { return this._BingMapInfoWindow_0_4; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this.detectContentChildrenChanges(throwOnChange);
    if (!throwOnChange) { if (this._query_BingMapInfoWindowAction_0_0.dirty) {
      this._query_BingMapInfoWindowAction_0_0.reset([]);
      this._BingMapInfoWindow_0_4.infoWindowActions = this._query_BingMapInfoWindowAction_0_0;
      this._query_BingMapInfoWindowAction_0_0.notifyOnChanges();
    } }
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_BingMapInfoWindow_Host0(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import2.AppElement):import1.AppView<any> {
  if ((renderType_BingMapInfoWindow_Host === (null as any))) { (renderType_BingMapInfoWindow_Host = viewUtils.createRenderComponentType('',0,import10.ViewEncapsulation.None,[],{})); }
  return new _View_BingMapInfoWindow_Host0(viewUtils,parentInjector,declarationEl);
}
export const BingMapInfoWindowNgFactory:import11.ComponentFactory<import3.BingMapInfoWindow> = new import11.ComponentFactory<import3.BingMapInfoWindow>('bing-map-info-window',viewFactory_BingMapInfoWindow_Host0,import3.BingMapInfoWindow);
const styles_BingMapInfoWindow:any[] = [];
var renderType_BingMapInfoWindow:import0.RenderComponentType = (null as any);
class _View_BingMapInfoWindow0 extends import1.AppView<import3.BingMapInfoWindow> {
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import2.AppElement) {
    super(_View_BingMapInfoWindow0,renderType_BingMapInfoWindow,import7.ViewType.COMPONENT,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import2.AppElement {
    const parentRenderNode:any = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
    this.init([],[],[],[]);
    return (null as any);
  }
}
export function viewFactory_BingMapInfoWindow0(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import2.AppElement):import1.AppView<import3.BingMapInfoWindow> {
  if ((renderType_BingMapInfoWindow === (null as any))) { (renderType_BingMapInfoWindow = viewUtils.createRenderComponentType('C:/Projects/git/youjustgo/ng2-bingmaps/src/directives/bing-map-info-window.ts class BingMapInfoWindow - inline template',0,import10.ViewEncapsulation.None,styles_BingMapInfoWindow,{})); }
  return new _View_BingMapInfoWindow0(viewUtils,parentInjector,declarationEl);
}